// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Checkbox_wrapper_3mnjk","box":"Checkbox_box_2KVrw","active":"Checkbox_active_2B5Fq","base":"Checkbox_base_2KMF-"};